import { Box, Grid } from "@mui/material";
import { useMediaQuery } from "@mui/system";
import { settings } from "app";
import BackButtonToolbar from "features/BackButtonToolbar";
import {
  FunctionField,
  Labeled,
  ReferenceField,
  Show,
  SimpleShowLayout,
  TextField,
  useRecordContext,
} from "react-admin";
import { paymentRequests } from "api/paymentApi";
import { DoctoralSchoolCampaignStatusChoices, DoctoralSchoolCampaignStatusColorMap } from "utils/choices";
import permissions from "app/permissions";
import SecuredComponent from "server/security/SecuredComponent";
import StatusChip from "../Partials/StatusChip";
import CandidatesSection from "./Show/CandidatesSection";
import ClassesSection from "./Show/ClassesSection";
import DoctoralDateField from "../Partials/DoctoralDateField";
import { SectionTitle } from "features/SectionTitle";

const StatusField = () => {
  const record = useRecordContext();
  if (!record) return null;
  return (
    <StatusChip
      status={record.status}
      choices={DoctoralSchoolCampaignStatusChoices}
      colorMap={DoctoralSchoolCampaignStatusColorMap}
    />
  );
};

const ShowDoctoralSchoolCampaign = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <Show
      title="Детайли за кампания за докторантско училище"
      actions={<BackButtonToolbar />}
    >
      <SimpleShowLayout>
        <SectionTitle
          title="Информация"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />

        <Grid
          container
          spacing={3}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid item xs={12} md={6}>
            <Labeled label="Име на български език">
              <TextField source="nameBg" />
            </Labeled>
          </Grid>
          <Grid item xs={12} md={6}>
            <Labeled label="Име на английски език">
              <TextField source="nameEn" />
            </Labeled>
          </Grid>
                              <Grid item xs={12} md={4}>
            <Labeled label="IBAN за плащане">
              <ReferenceField
                source="ibanId"
                reference={paymentRequests.getIbansSelect()}
                link={false}
                emptyText="-"
              >
                <TextField source="name" />
              </ReferenceField>
            </Labeled>
          </Grid>
          <Grid item xs={12} md={4}>
            <Labeled label="Статус">
              <FunctionField render={() => <StatusField />} />
            </Labeled>
          </Grid>
          <Grid item xs={12} md={3}>
            <Labeled label="Начало на училището">
              <DoctoralDateField source="dateFrom" showTime />
            </Labeled>
          </Grid>
          <Grid item xs={12} md={3}>
            <Labeled label="Край на училището">
              <DoctoralDateField source="dateTo" showTime />
            </Labeled>
          </Grid>
          <Grid item xs={12} md={3}>
            <Labeled label="Записване от">
              <DoctoralDateField source="enrollmentFrom" showTime />
            </Labeled>
          </Grid>
          <Grid item xs={12} md={3}>
            <Labeled label="Записване до">
              <DoctoralDateField source="enrollmentTo" showTime />
            </Labeled>
          </Grid>
        </Grid>

        <SectionTitle
          title="Програма"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <Box
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <ClassesSection />
        </Box>

        <SecuredComponent permission={permissions.canPreviewDoctoralSchoolDoctorants}>
          <SectionTitle
            title="Кандидати"
            textAlign="center"
            sx={{ marginTop: "2rem" }}
          />
          <Box
            sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
          >
            <CandidatesSection />
          </Box>
        </SecuredComponent>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowDoctoralSchoolCampaign;
